import type { DatasetViewColumn } from "../../../../api/types";

export function jsonProvenanceLabel(column: DatasetViewColumn): string {
  const source = column.source_column || "JSON document";
  return column.source_path ? `${source} ${column.source_path}` : source;
}